import React, { useState, useEffect } from "react";
import "../Admin/css/password.css";
import "../Admin/css/layout.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { secureStorage } from "../utils/secureStorage";
import { changePassword } from "../service/changepasswordService.js";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ChangePassword = () => {
 const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [show, setShow] = useState({
    old: false,
    new: false,
    confirm: false,
  });
  const [notification, setNotification] = useState({
  show: false,
  message: "",
  type: "success",
});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  

  if (form.newPassword !== form.confirmPassword) {
     showNotification(
    "New Password and Confirm Password do not match ⚠️",
    "error"
  );
    return;
  }

  if (form.newPassword.length < 6) {
    showNotification("Password must be at least 6 characters ⚠️", "error");
    return;
  }

  try {
     setLoading(true);
    const user = secureStorage.getuser();
    const id = user?.id;

    if (!id) {
      showNotification("User not found ❌", "error");
      return;
    }

    const payload = {
       old_pwd: form.oldPassword,
       new_pwd: form.newPassword,
       new_pwd_confirmation: form.confirmPassword,

    };

    const res = await changePassword(id, payload);

    console.log("Password Change Response:", res.data);

    showNotification("Password changed successfully ✅", "success");
  secureStorage.clear();
  navigate("/Admin");
    // ✅ Reset form
    setForm({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

  } catch (err) {
    console.error("Password Change Error:", err.response?.data || err.message);
    alert(err.response?.data?.message || "Failed to change password ❌");
  }
   
};

useEffect(() => {
  const scholar = secureStorage.getScholar();

  if (!scholar) {
    navigate("/", { replace: true });
  }
}, [navigate]);

const showNotification = (
  message,
  type = "success"
) => {

  setNotification({
    show: true,
    message,
    type,
  });

  setTimeout(() => {
    setNotification({
      show: false,
      message: "",
      type: "success",
    });
  }, 3000);
};

if (loading) {
    return (
      <>
        <div className="layout">
          <Sidebar/>
          <div className="main-area">
            <Header/>
        <div className="modern-loader-container">
     <div className="modern-loader-card">
    <div className="modern-loader-animation">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <h3>Loading Profile</h3>
    <p>Please wait while we fetch your profile details...</p>
  </div>
</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
     <div className="layout">
        <Sidebar/>
         <div className="main-area">
            <Header/>
    <div className="change-password-container">
      <form className="change-password-card" onSubmit={handleSubmit}>
        <h2>Change Password</h2>

        {/* Old Password */}
        <div className="input-group">
          <label>Old Password</label>
          <div className="password-field">
            <input
            placeholder="Enter Old Password"
              type={show.old ? "text" : "password"}
              name="oldPassword"
              value={form.oldPassword}
              onChange={handleChange}
              required
            />
            <span onClick={() => setShow({ ...show, old: !show.old })}>
              {show.old ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
        </div>

        {/* New Password */}
        <div className="input-group">
          <label>New Password</label>
          <div className="password-field">
            <input
            placeholder="Enter New Password"
              type={show.new ? "text" : "password"}
              name="newPassword"
              value={form.newPassword}
              onChange={handleChange}
              required
            />
            <span onClick={() => setShow({ ...show, new: !show.new })}>
              {show.new ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
        </div>

        {/* Confirm Password */}
        <div className="input-group">
          <label>Confirm Password</label>
          <div className="password-field">
            <input
            placeholder="Enter Confirm Password"
              type={show.confirm ? "text" : "password"}
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
           <span onClick={() => setShow({ ...show, confirm: !show.confirm })}>
  {show.confirm ? < FaEye/> : <FaEyeSlash />}
</span>
          </div>
        </div>

        <button type="submit" className="btn">
          Update Password
        </button>
      </form>
    </div>
    {notification.show && (
  <div
    className={`password-notification ${notification.type}`}
  >
    <div className="password-notification-content">

      <div className="password-notification-icon">
        {notification.type === "success"
          ? "✓"
          : "⚠"}
      </div>

      <div>
        <h4>
          {notification.type === "success"
            ? "Success"
            : "Error"}
        </h4>

        <p>{notification.message}</p>
      </div>

    </div>
  </div>
)}
    </div>
    </div>
    </>
  );
};

export default ChangePassword;